import React, { useEffect, useState } from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';

import Spinner from '../components/Spinner';
import { BookingsProvider } from '../contexts/BookingsContext';
import { CopilotProvider } from '../contexts/CopilotContext';
import { SessionProvider } from '../contexts/SessionContext';
import AIDocumentEditor from '../pages/AIDocumentEditor';
import Home from '../pages/Home';
import NotFound from '../pages/NotFound';
import VirtualSession from '../pages/VirtualSession';
import { retrieveItem, storeItem } from '../utils/helpers';
import { CanvasSketchProvider } from '../contexts/CanvasSketchContext';
import { AIDocumentEditorProvider } from '../contexts/AIDocumentEditorContext';

const AuthenticatedRoutes: React.FunctionComponent = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const authenticateUser = () => {
    const queryParams = window.location.search;
    const authToken = new URLSearchParams(queryParams).get('authToken');
    const savedAuthToken = retrieveItem('hp_auth_token');
    const baseUrl = window.location.href.replace(queryParams, '');

    try {
      if (authToken) {
        storeItem('hp_auth_token', authToken);
        window.location.href = baseUrl;
        setIsLoading(false);
      } else if (savedAuthToken) {
        setIsLoading(false);
      } else {
        window.location.href =
          window._env_?.AUTH_APP_URL ||
          process.env.REACT_APP_AUTH_APP_URL ||
          '';
      }
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    authenticateUser();
  }, []);

  if (isLoading) {
    return <Spinner open={isLoading} />;
  }

  return (
    <BookingsProvider>
      <SessionProvider>
        <CanvasSketchProvider>
          <CopilotProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/inspector/:booking_session_code"
                  element={<VirtualSession />}
                />
                <Route path="/manage-report/:booking_id" element={<></>} />
                <Route
                  path="/edit-report/:booking_id"
                  element={
                    <AIDocumentEditorProvider>
                      <AIDocumentEditor />
                    </AIDocumentEditorProvider>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </CopilotProvider>
        </CanvasSketchProvider>
      </SessionProvider>
    </BookingsProvider>
  );
};

/*
import { Provider, createStore } from 'jotai';
import { DailyProvider, useCallObject } from '@daily-co/daily-react';
import App from '@/components/App';
import { Container, Section, Heading, Flex } from '@radix-ui/themes';

const jotaiStore = createStore();

export default function Home() {
  const callObject = useCallObject({});

  return (
    <Provider store={jotaiStore}>
      <DailyProvider callObject={callObject} jotaiStore={jotaiStore}>
        <Container size="3" p="4" id="app">
          <Flex direction="column" gap="3">
            <Section size="2">
              <Heading align="center" as="h1">
                Daily Network Test
              </Heading>
            </Section>

            <Section size="2" style={{ textAlign: 'center' }}>
              <App />
            </Section>
          </Flex>
        </Container>
      </DailyProvider>
    </Provider>
  );
}
*/

export default AuthenticatedRoutes;
